const DEFAULT_AUTO_HIDE_DELAY = 5000;
const TOASTER_POSITION_CLASSES = {
	'b-toaster-top-right': 'b-toaster-top-right',
};

const getToaster = (toaster = 'b-toaster-top-right') => {
	const className = TOASTER_POSITION_CLASSES[toaster] || TOASTER_POSITION_CLASSES['b-toaster-top-right'];
	let container = document.querySelector(`.bv-toast-container.${className}`);

	if (!container) {
		container = document.createElement('div');
		container.className = `bv-toast-container ${className}`;
		document.body.appendChild(container);
	}

	return container;
};

const removeToast = (toast) => {
	toast.classList.remove('show');

	window.setTimeout(() => {
		toast.remove();
	}, 150);
};

const showToastElement = (id) => {
	const toast = document.getElementById(id);

	if (!toast) {
		return;
	}

	toast.classList.add('show');
	toast.style.display = 'block';

	window.setTimeout(() => {
		toast.classList.remove('show');
	}, DEFAULT_AUTO_HIDE_DELAY);
};

const toast = (message, options = {}) => {
	const container = getToaster(options.toaster);
	const toastElement = document.createElement('div');
	const variant = options.variant || 'info';
	const title = options.title || '';
	const autoHideDelay = options.autoHideDelay ?? DEFAULT_AUTO_HIDE_DELAY;
	const header = document.createElement('div');
	const titleElement = document.createElement('strong');
	const closeButton = document.createElement('button');
	const closeIcon = document.createElement('span');
	const body = document.createElement('div');

	toastElement.className = `toast b-toast b-toast-${variant} show`;
	toastElement.setAttribute('role', 'alert');
	toastElement.setAttribute('aria-live', 'assertive');
	toastElement.setAttribute('aria-atomic', 'true');

	header.className = 'toast-header';
	titleElement.className = 'me-auto';
	titleElement.textContent = title;
	closeButton.type = 'button';
	closeButton.className = 'close';
	closeButton.setAttribute('aria-label', 'Close');
	closeIcon.setAttribute('aria-hidden', 'true');
	closeIcon.textContent = '\u00d7';
	body.className = 'toast-body';
	body.textContent = message;

	closeButton.appendChild(closeIcon);
	header.append(titleElement, closeButton);
	toastElement.append(header, body);
	closeButton.addEventListener('click', () => removeToast(toastElement));
	container.appendChild(toastElement);

	if (autoHideDelay) {
		window.setTimeout(() => removeToast(toastElement), autoHideDelay);
	}
};

export const BootstrapVueToastPlugin = {
	install(app) {
		const bvToast = {
			show: showToastElement,
			toast,
		};

		app.config.globalProperties.$bvToast = bvToast;
		app.provide('bvToast', bvToast);
	},
};
